<template>
  <teleport to="body">
    <div :class="fadeTransition" class="modal">
      <div class="modal-body" :class="bounceTransition">
        <div class="close-svg" @click="closeModal">
          <CloseSVG :propId="'print-close'" :fillColor="'#f7f9fc'" />
        </div>
        <h1 class="modal-header">
          <div id="return" @click="returnToTroubleShooting">
            <img src="@/assets/blue-arrow-left.svg" />
            <span>Return to Troubleshooting</span>
          </div>
        </h1>
        <div class="modal-content">
          <div id="info">
            <div id="title">My print is shifted up or down</div>
            <p>
              If your printed artwork is shifted up or down from the labels the issue is likely
              related to your printed paper settings. In your printer settings set your
              <strong>Paper</strong> or
              <strong>Media Type</strong> to
              <strong>Labels</strong> or a
              similar setting such as
              <strong>Heavyweight Paper</strong>.
            </p>
            <p>
              If your paper setting is correct you may need to manually configure your template to
              work with your printer.
            </p>
            <div v-if="clientDimensions.width <= 900" id="img-wrap">
              <img src="@/assets/printing-assets/issue-2.svg" />
            </div>
            <div id="template-select" @click="configureTemplate">Manually Configure My Template</div>
          </div>
          <div v-if="clientDimensions.width > 900" id="img-wrap">
            <img src="@/assets/printing-assets/issue-2.svg" />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, computed, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ClientDimensions } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "ShiftedVertical",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const clientDimensions = computed<ClientDimensions>(() => store.getters.clientDimensions);

    const returnToTroubleShooting = () => {
      store.dispatch(ActionTypes.SET_MODAL, "troubleShooting");
    };

    const configureTemplate = () => {
      store.dispatch(ActionTypes.SET_MODAL, "alignmentWizard");
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      clientDimensions,
      returnToTroubleShooting,
      configureTemplate,
    };
  },
});
</script>

<style scoped>
.modal-body {
  padding: 4rem;
  height: auto;
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  color: #000;
  padding-left: 2rem;
}

#return {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  color: #0096ff;
  cursor: pointer;
}

#return img {
  margin-right: 0.5rem;
  height: 1.5rem;
}

.modal-content {
  display: flex;
  justify-content: space-between;
}

#info {
  display: flex;
  flex-direction: column;
  padding: 2rem;
}

#info,
#img-wrap {
  width: 50%;
}

#info > * {
  margin: 2rem 0;
}

#title {
  display: flex;
  align-items: center;
  font-size: 3rem;
  font-weight: 700;
}

#info p {
  font-size: 1.5rem;
}

#template-select {
  color: #fff;
  background-color: #ff6c00;
  border: 1px solid transparent;
  border-radius: 6px;
  text-align: center;
  padding: 2rem;
  font-size: 2rem;
  font-weight: 800;
}

#template-select:hover {
  background: linear-gradient(to bottom, #ff994e 0%, #ff6c00 100%);
}

#img-wrap {
  padding: 2rem;
  display: flex;
  align-items: center;
}

#img-wrap img {
  width: 100%;
  height: auto;
  max-width: 380px;
  margin: auto;
}

@media (max-width: 900px) {
  .modal-body {
    padding: 4rem 2rem 2rem 2rem;
  }

  .modal-content {
    height: auto;
  }

  #info {
    width: 100%;
    align-items: center;
  }

  #img-wrap {
    padding: 0;
  }

  #img-wrap img {
    width: 100%;
  }

  #template-select {
    margin-top: 2rem;
    padding: 2.5rem 4rem;
  }
}

@media (max-width: 550px) {
  .modal-body {
    height: 90%;
    width: 95%;
    max-height: none;
  }
}
</style>
